import { createSelector, createRootSelector } from '../../../utils/createSelector';
import type { GridColDef } from '../../../models/colDef';
import type { GridStateCommunity } from '../../../models/gridStateCommunity';
import type { GridPivotingStatePartial } from './gridPivotingInterfaces';

const gridPivotingStateSelector = createRootSelector(
  // @ts-expect-error Pivoting is added to community state only by Premium augmentation.
  (state: GridStateCommunity) => state.pivoting as GridPivotingStatePartial,
);

export const gridPivotActiveSelector = createSelector(
  gridPivotingStateSelector,
  (pivoting) => pivoting?.active,
);

const emptyColumns = new Map<string, GridColDef>();

export const gridPivotInitialColumnsSelector = createSelector(
  gridPivotingStateSelector,
  (pivoting) => pivoting?.initialColumns || emptyColumns,
);
